import React, { Component } from 'react'

import Repository from '../../felles/repository'
import Panel from 'react-bootstrap/lib/Panel'

import { ButtonToolbar } from 'react-bootstrap'
import NkaButton from 'nka-button'
import JaNeiDialog from '../../felles/Dialogs/JaNeiDialog.jsx'
import MaalertyperModal from './maalertyperModal'
import { resolve } from '../../dependencies'

import 'nka-button/dist/style.css'

var divStyle = {
    padding: '10px'
}

export default class Maalertyper extends Component {
    constructor(props) {
        super(props)
        this._repository = new Repository()

        this.state = {
            isNyModalOpen: false,
            isFjernModalOpen: false,
            endre: false,
            tittel: '',
            beskrivelse: '',
            planlagtdato: null,
            id: '',
            tekst: '',
            fabrikatId: '',
            typeId: '',
            dimensjonId: '',
            kapasitetId: '',
            retningId: '',
            temp: '',
            antallSiffer: '',
            idSomSkalFjernes: 0,
            brukerLora: false
        }

        this._openNyModal = this._openNyModal.bind(this)
        this._closeNyModal = this._closeNyModal.bind(this)
        this._visSlettType = this._visSlettType.bind(this)
        this._endreType = this._endreType.bind(this)
        this._lukkFjerntypeDialog = this._lukkFjerntypeDialog.bind(this)
        this._fjernType = this._fjernType.bind(this)
        this._oppdaterfraModal = this._oppdaterfraModal.bind(this)
        this._etterFjernMaaler = this._etterFjernMaaler.bind(this)
    }

    _closeNyModal() {
        this.setState({ isNyModalOpen: false })
        this.props.oppdaterliste()
        this.setState({})
    }

    _visSlettType(id) {
        this.setState({
            idSomSkalFjernes: id,
            isFjernModalOpen: true
        })
    }

    _fjernType() {
        resolve(Repository).slettEgendefinerteMaalertype(this.state.idSomSkalFjernes).then(this._etterFjernMaaler)
    }

    _etterFjernMaaler() {
        this.setState({
            idSomSkalFjernes: 0,
            isFjernModalOpen: false
        })
        this.props.oppdaterliste()
    }

    _oppdaterfraModal() {
        this.props.oppdaterliste()
    }

    _lukkFjerntypeDialog() {
        this.setState({
            idSomSkalFjernes: 0,
            isFjernModalOpen: false
        })
    }

    _endreType(id) {
        //Finne denne i utvalget og sett verdiene i state
        for (var i = 0; i < this.props.maalertyper.length; i++) {
            if (this.props.maalertyper[i].Id === id) {
                this.setState({ id: this.props.maalertyper[i].Id })
                this.setState({ tekst: this.props.maalertyper[i].Tekst })
                this.setState({ fabrikatId: this.props.maalertyper[i].FabrikatId })
                this.setState({ typeId: this.props.maalertyper[i].TypeId })
                this.setState({ dimensjonId: this.props.maalertyper[i].DimensjonId })
                this.setState({ kapasitetId: this.props.maalertyper[i].Kapasitet })
                this.setState({ retningId: this.props.maalertyper[i].RetningId })
                this.setState({ antallSiffer: this.props.maalertyper[i].Antallsiffer })
                this.setState({ temp: this.props.maalertyper[i].Temperatur })
                this.setState({ maalernummerPrefix: this.props.maalertyper[i].MaalernummerPrefix })
                this.setState({ brukerLora: this.props.maalertyper[i].BrukerLora })
                this.setState({ isNyModalOpen: true })
            }
        }
    }

    _openNyModal() {
        this.setState({
            tittel: '',
            beskrivelse: '',
            planlagtdato: '',
            id: '',
            tekst: '',
            fabrikatId: '',
            typeId: '',
            dimensjonId: '',
            retningId: '',
            antallSiffer: '',
            kapasitet: '',
            temp: '',
            maalernummerPrefix: '',
            isNyModalOpen: true,
            endre: false
        })
    }

    render() {
        return (
            <div>
                <div style={divStyle}>
                    <h2>Forhåndsdefinerte målere</h2>
                    <ButtonToolbar>
                        <NkaButton icon="pluss" onClick={this._openNyModal}>
                            Ny forhåndsdefinert måler
                        </NkaButton>
                    </ButtonToolbar>
                    <br />
                    {this.props.maalertyper.map((st, index) => (
                        <div key={st.Id}>
                            <Panel key={st.Id}>
                                <div style={divStyle}>
                                    <h4>{st.Tekst}</h4>
                                    <p>
                                        <b>Fabrikat:</b> {st.FabrikatTekst}
                                    </p>
                                    <p>
                                        <b>Type:</b> {st.TypeTekst}
                                    </p>
                                    <p>
                                        <b>Dimensjon:</b> {st.DimensjonTekst}
                                    </p>
                                    <p>
                                        <b>Retning:</b> {st.RetningTekst}
                                    </p>
                                    <p>
                                        <b>Temperatur:</b> {st.TemperaturTekst}
                                    </p>
                                    <p>
                                        <b>Antall siffer:</b> {st.Antallsiffer}
                                    </p>
                                    <p>
                                        <b>Kapasitet:</b> {st.KapasitetTekst}
                                    </p>
                                    <p>
                                        <b>Målernummer prefix:</b> {st.MaalernummerPrefix}
                                    </p>
                                    <p>
                                        <b>Kommunikasjon</b> {st.BrukerLora ? 'Lora' : ''}
                                    </p>
                                    <p>
                                        <NkaButton onClick={() => this._endreType(st.Id)}>
                                            Endre{' '}
                                        </NkaButton>{' '}
                                        <NkaButton onClick={() => this._visSlettType(st.Id)}>
                                            Slett{' '}
                                        </NkaButton>{' '}
                                    </p>
                                </div>
                            </Panel>
                            <br />
                        </div>
                    ))}
                </div>

                {this.state.isNyModalOpen ? (
                    <MaalertyperModal
                        onClose={this._closeNyModal}
                        isOpen={this.state.isNyModalOpen}
                        fabrikat={this.props.fabrikat}
                        dimensjon={this.props.dimensjon}
                        oppdaterliste={this._oppdaterfraModal}
                        retning={this.props.retning}
                        typer={this.props.typer}
                        tekst={this.state.tekst}
                        fabrikatId={this.state.fabrikatId}
                        typeId={this.state.typeId}
                        dimensjonId={this.state.dimensjonId}
                        kapasitet={this.props.kapasitet}
                        kapasitetId={this.state.kapasitetId}
                        retningId={this.state.retningId}
                        brukerLora={this.state.brukerLora}
                        id={this.state.id}
                        antallSiffer={this.state.antallSiffer}
                        temp={this.state.temp}
                        maalernummerPrefix={this.state.maalernummerPrefix}
                    />
                ) : (
                        <div />
                    )}

                {this.state.isFjernModalOpen && (
                    <JaNeiDialog
                        melding="Fjerner forhåndsdefinert måler. Vil du fortsette?"
                        isOpen={this.state.isFjernModalOpen}
                        tittel="Fjern forhåndsdefinert måler"
                        onAvbryt={this._lukkFjerntypeDialog}
                        onOk={this._fjernType}
                    />
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/innstillinger/maalertyper/maalertyper.jsx